import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AuthService, BadRequestHandler, GlobalMessageType, RoutingService} from '@spartacus/core';
import {EfaGlobalMessageService} from '@shared/services/efa-global-message.service';

const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';
const SUBARU_ASP_ROUTE_NAME = 'subaruAsp';

@Injectable({
  providedIn: 'root',
})
export class EfaBadRequestHandler extends BadRequestHandler {
  constructor(
    protected globalMessageService: EfaGlobalMessageService,
    private routingService: RoutingService,
    private authService: AuthService) {
    super(globalMessageService);
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handleSubaruAspAuthenticationError(request,response);
    this.handlePlaceOrderTimeoutError(request, response);
    this.handlePlaceOrderDuplicateError(request, response);
    this.handlePlaceOrderUnknownError(request, response);
    this.handleCalculationError(request, response);
    super.handleError(request, response);
  }

  private handleCalculationError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handlePlaceOrderError(request, response, 'CalculationError', 'efaHttpHandlers.calculationError');
  }

  private handlePlaceOrderTimeoutError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handlePlaceOrderError(request, response, 'PlaceOrderTimeoutError', 'efaHttpHandlers.placeOrderTimeoutError');
  }

  private handlePlaceOrderError(request: HttpRequest<any>,
                                response: HttpErrorResponse,
                                errorType: string,
                                messageKey: string,
                                redirectUrl?: string): void {
    if (response && response.error && response.error.errors && response.error.errors[0] && response.error.errors[0]?.type === errorType) {
      this.globalMessageService.add(
        {
          key: messageKey
        },
        GlobalMessageType.MSG_TYPE_ERROR
      );
      if (redirectUrl) {
        this.routingService.go(redirectUrl, {
          state: {
            messageTypesForRemoval: [GlobalMessageType.MSG_TYPE_WARNING,
              GlobalMessageType.MSG_TYPE_CONFIRMATION,
              GlobalMessageType.MSG_TYPE_INFO]
          }
        });
      }
    }
  }

  private handlePlaceOrderDuplicateError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handlePlaceOrderError(request, response, 'PlaceOrderDuplicateError', 'efaHttpHandlers.placeOrderDuplicateError', '/');
  }

  private handlePlaceOrderUnknownError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    this.handlePlaceOrderError(request, response, 'PlaceOrderUnknownError', 'checkoutOrder.globalMessage.placeOrderFailed');
  }

  private handleSubaruAspAuthenticationError(request: HttpRequest<any>,
                                response: HttpErrorResponse): void {
    let messageKey='';
    let redirectToSubaruAspPage: boolean = false;
    if (response && response.error && response.error.errors && response.error.errors[0]) {
      if (response.error.errors[0]?.type === 'SubaruAspAuthenticationError') {
        messageKey = 'efaHttpHandlers.subaruAspAuthenticationError';
      } else if (response.error.errors[0]?.type === 'ExpiredJwtError' || response.error.errors[0]?.type === 'SignatureError') {
        console.log("JWT Token was not valid and will be renewed: Error: " + response.error.errors[0]?.type)
        redirectToSubaruAspPage = true;
      }
    }
    if (messageKey.length > 0)
    {
      this.globalMessageService.add(
        {
          key: messageKey
        },
        GlobalMessageType.MSG_TYPE_ERROR
      );
    }

    if (redirectToSubaruAspPage) {
      this.authService.coreLogout().then(() => {
        const redirectUrl: string = this.routingService.getFullUrl({cxRoute: SUBARU_ASP_ROUTE_NAME});
        window.location.href = redirectUrl;
      });
    }
  }
}
